import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import TermsConditionInfo from './TermsConditionInfo';
class TermsCondition extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="Terms of Use"/>
          <TermsConditionInfo/>
          <Footer />
        </div>
    );
  }
}

export default TermsCondition;
